export default {
  entidades: 'Entidades',
  configuracion: 'Configuraciones',
  usuarios: 'Usuarios',
  modulos: 'Módulos y permisos',
  roles: 'Roles',
  parametros: 'Preferencias',
  logs: 'Logs del sistema',
  config: 'Configuraciones'
};



// WEBPACK FOOTER //
// ./src/common/lang/es/menu.js